import React from 'react';
import { QRData } from '../../types/qr';
import { HandleInputChangeFunction } from '../QRCodeGenerator';
import { Form, Input, TextArea } from '../styled/FormElements';

interface EmailQRFormProps {
  qrData: QRData;
  handleInputChange: HandleInputChangeFunction;
}

export const EmailQRForm: React.FC<EmailQRFormProps> = ({ qrData, handleInputChange }) => {
  return (
    <Form>
      <Input
        type="email"
        name="address"
        value={qrData.email.address}
        onChange={(e) => handleInputChange(e, "email")}
        placeholder="Email Address"
      />
      <Input
        type="text"
        name="subject"
        value={qrData.email.subject}
        onChange={(e) => handleInputChange(e, "email")}
        placeholder="Subject"
      />
      <TextArea
        name="message"
        value={qrData.email.message}
        onChange={(e) => handleInputChange(e, "email")}
        placeholder="Body"
      />
    </Form>
  );
};